import React, {useEffect} from 'react'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Button } from '@mui/material'
import {
    CallbackInput,
    ContactsContent,
    ContactsForm,
    ContactsText,
    ContactsTitle,
    ContactsWrapper,
    FlexBox,
    InputTextInput,
    SectionContainer,
} from '../style'

const Contacts = () => {
    const { formatMessage } = useIntl()

    useEffect(() => {
        // Создаем и добавляем первый скрипт для формы amoCRM
        const amoScript = document.createElement("script");
        amoScript.innerHTML = `
          !function(a,m,o,c,r,m){
            a[o+c]=a[o+c]||{setMeta:function(p){this.params=(this.params||[]).concat([p])}};
            a[o+r]=a[o+r]||function(f){a[o+r].f=(a[o+r].f||[]).concat([f])};
            a[o+r]({id:"1463062",hash:"3c2fde7020cdf12222ecd5727a8bd2f6",locale:"ru"});
            a[o+m]=a[o+m]||function(f,k){a[o+m].f=(a[o+m].f||[]).concat([[f,k]])};
          }(window,0,"amo_forms_","params","load","loaded");
        `;
        document.body.appendChild(amoScript);
    
        // Создаем и добавляем второй скрипт для загрузки формы
        const amoFormScript = document.createElement("script");
        amoFormScript.id = "amoforms_script_1463062";
        amoFormScript.async = true;
        amoFormScript.charset = "utf-8";
        amoFormScript.src = "https://forms.amocrm.ru/forms/assets/js/amoforms.js?1734502780";
        document.body.appendChild(amoFormScript);
    
        // Функция для перемещения iframe в нужный контейнер
        const moveIframe = () => {
          const iframe = document.getElementById('amoforms_iframe_1463062');
          const container = document.getElementById('react-amo-form');
          if (iframe && container) {
            container.appendChild(iframe); // Перемещаем iframe в контейнер
          }
        };
    
        // Задержка для того, чтобы форма успела загрузиться
        const interval = setInterval(() => {
          if (document.getElementById('amoforms_iframe_1463062')) {
            moveIframe();
            clearInterval(interval); // Останавливаем интервал, когда iframe найден
          }
        }, 100); // Проверка каждые 100 мс
    
        // Очищаем скрипты и интервал при размонтировании компонента
        return () => {
          document.body.removeChild(amoScript);
          document.body.removeChild(amoFormScript);
          clearInterval(interval);
        };
      }, []); // Эффект срабатывает один раз при монтировании компонента

    return (
        <SectionContainer>
            <ContactsWrapper>
                <ContactsContent>
                    <ContactsTitle>
                        {formatMessage({ id: 'leaveRequest' })}
                    </ContactsTitle>
                    <ContactsText>
                        {formatMessage({ id: 'leaveRequestDescription' })}
                    </ContactsText>
                </ContactsContent>
                
                <ContactsForm>
                    <div style={{width: '100%'}} id="react-amo-form" />
                </ContactsForm>
            </ContactsWrapper>
        </SectionContainer>
    )
}

export default Contacts
